import "devextreme/data/odata/store"

import { DxButton } from 'devextreme-vue'

import { contactService } from '../../../services/contact.service'

import moment from "moment"

import notify from 'devextreme/ui/notify'

export default {
  components: {
    DxButton,
  },
  data() {
    return {
      loading: true,
      success: false,
      currentBizContact: {
        bizContactName: '',
        publishStartDateTime: '',
        bizContactContent: ''
      },
    }
  },
  computed: {
    publishStartDateTime() {
      return moment(this.currentBizContact.publishStartDateTime).format("YYYY/MM/DD");
    },
    isShowUrl() {
      return this.isStringNotEmpty(this.currentBizContact.url) && this.isStringNotEmpty(this.currentBizContact.urlTitle)
    },
  },
  methods: {
    fetchBizContactDetailData() {

      let self = this

      var bizContactId = this.$route.params.bizcontactid

      contactService.getBizContact(bizContactId)
        .then(
          success => {

            if (success.messageType == 1) {

              self.currentBizContact = success.content

              if (self.currentBizContact.publishStatusId == 2 && self.currentBizContact.openStatusId == 1) {

                self.currentBizContact.openStatusId = 2
                self.currentBizContact._State_ = 4

                contactService.updateBizContactReadStatus(self.currentBizContact)
                  .then(
                    success => {
                      if (success.messageType == 0) {
                        self.showMessage(success.message, 'error');
                      }
                    },
                    error => {
                      console.log(error)
                    }
                  )
              }
            } else {
              self.showMessage(success.message, 'error');
            }

            self.loading = false
            self.success = true
          },
          error => {

            self.loading = false

            console.log(error)
          }
        )
    },
    onClickBackToBizContactList() {
      if (this.$store.state.fromUrlName != null && this.$store.state.fromUrlName != "") {
        this.$router.push({ name: this.$store.state.fromUrlName })
      } else {
        this.$router.push({ name: "biz-contact-list" })
      }
    },
    isStringNotEmpty(str){
      if(str == null ) return false
      if(str == undefined ) return false
      if(str.length == 0) return false
      if(str.replace(/\s*/g,"").length ==0) return false
      return true
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  created() {
    this.fetchBizContactDetailData()
  },
  watch: {
    '$route': 'fetchBizContactDetailData'
  },
}